export { c as buttonColor, e as buttonEqualSizes, f as buttonFill, s as buttonShape, a as buttonShapeEqual, b as buttonSize, d as buttonSizes, g as checkboxSize, j as headingDisplayPresets, k as headingDisplaySizes, p as headingPresets, h as headingSize, i as headingSizes, c as iconButtonColor, f as iconButtonFill, a as iconButtonShape, b as iconButtonSize, m as iconSize, l as iconSizes, l as loaderSizes, g as radioSize, g as sliderSize, n as tabSize, r as textPresets, o as textSize, q as textSizes } from './tabs-ea0cc499.esm.js';
import { i as space, e as presets } from './typography-b778f0e8.esm.js';
export { e as borderPresets, b as borderWidths, f as borders, a as breakpoints, s as colorSchemes, d as colorSchemesBrand, p as colorSchemesProduct, c as colors, m as motion, r as radii, g as shadows, h as sizes, i as space, t as typography } from './typography-b778f0e8.esm.js';
import _curry from 'ramda/src/curry';
import { math } from 'polished';
import '@hover/tokens-border';
import '@hover/tokens-device';
import * as tokens from '@hover/tokens-color';
export { tokens as colorTokens };
import 'ramda/src/map';
import '@hover/tokens-motion';
import '@hover/tokens-depth';
import '@hover/tokens-size';
import '@hover/tokens-typography';
import './objectSpread2-b7b195c3.esm.js';
import '@hover/tokens-space';
import 'ramda/src/pick';

var spaceForBorder = /*#__PURE__*/_curry(function (border, space$1) {
  return math("".concat(space[space$1], " - ").concat(presets[border].borderWidth));
});

export { spaceForBorder };
